class ProductAvailabilityMessage extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    if (!this.section) return;

    this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
    this.section.addEventListener('variant:update', this.handleVariantUpdate);
  }

  disconnectedCallback() {
    if (this.section) {
      this.section.removeEventListener('variant:update', this.handleVariantUpdate);
    }
  }

  handleVariantUpdate(event) {
    const updatedHtml = event.detail?.data?.html;
    if (!updatedHtml) return;

    const updatedMessage = updatedHtml.querySelector('[data-product-availability-message]');
    if (!updatedMessage) {
      this.innerHTML = '';
      return;
    }

    this.innerHTML = updatedMessage.innerHTML;
  }
}

if (!customElements.get('product-availability-message')) {
  customElements.define('product-availability-message', ProductAvailabilityMessage);
}